import { ArrowLeft } from 'assets/icons/index.js';
import TbodyListVivier from "./components/tbody.list.vivier";
import ScrollableTableWrapper, { useScrollContext } from '../../../../../../components/table/components/ScrollableTableWrapper';

const thClass = "sticky top-0 z-10 py-3.5 px-2 text-left text-sm font-medium text-gray-700 bg-gray-50 border-b border-gray-100 relative";

const Thead = ({ setSortName, sortName, departments = [] }) => {
    const { hasHorizontalScroll = false } = useScrollContext();
    return (
        <tr className="sticky top-0 z-10 border-b border-gray-100">
            <th
                scope="col"
                className="sticky top-0 left-0 z-20 py-3.5 pl-4 pr-2 font-medium text-left text-sm text-gray-700 w-80 bg-gray-50 border-b border-gray-100 cursor-pointer"
                onClick={() => setSortName((prev) => !prev)}
                style={hasHorizontalScroll ? { boxShadow: '2px 0 0 0 rgba(243, 244, 246, 1)' } : {}}
            >
                <div className="flex items-center gap-8">
                    <span>NOM</span>
                    <div className={sortName ? "rotate-90" : "-rotate-90"}>
                        <ArrowLeft w={12} />
                    </div>
                </div>
            </th>
            <th scope="col" className={`${thClass} w-28`}>NB PROFILS</th>
            {departments.map((dept) => (
                <th key={dept} scope="col" className={`${thClass} w-28`}>{dept.toUpperCase()}</th>
            ))}
            <th scope="col" className={`${thClass} w-36`}>CRÉE LE</th>
            <th scope="col" className={`${thClass} w-36`}>UTILISÉ LE</th>
            <th scope="col" className={`${thClass} w-12`} />
        </tr>
    );
};

const TableListVivier = ({ viviers, setSortName, sortName, navigateToFicheVivier, departments = [] }) => (
    <ScrollableTableWrapper className="overflow-y-auto">
        <table className="table-fixed w-full divide-y divide-gray-200 bg-white animate-fadeIn">
            <thead className="sticky top-0 z-10">
                <Thead setSortName={setSortName} sortName={sortName} departments={departments} />
            </thead>
            <tbody>
                {viviers?.map((vivier) => (
                    <TbodyListVivier key={vivier._id} champsBody={vivier} navigateToFicheVivier={navigateToFicheVivier} departments={departments} />
                ))}
            </tbody>
        </table>
    </ScrollableTableWrapper>
);

export default TableListVivier;